import React, { useState, useRef, useMemo, useEffect } from "react";
import { shallowEqual, useSelector, useDispatch } from "react-redux";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar,
} from "../../../_metronic/_partials/controls";
import { BannerEditAddForm } from "./BannerEditAddForm";
import { useSnackbar } from "notistack";

import { Link } from "react-router-dom";
import { ModalProgressBar } from "../../../_metronic/_partials/controls";
import { useSubheader } from "../../../_metronic/layout";
import { createMarketingBanner, fetchSingleMarketingBanner, updateMarketingBanner } from "../../../actions/banners/banners";

export function BannerEdit({
  history,
  match: {
    params: { id },
  },
}) {

  const { enqueueSnackbar } = useSnackbar();

  const { totalCount } = useSelector(
    (state) => ({
      totalCount:
        state.banners &&
        state.banners.marketingBanner &&
        state.banners.marketingBanner.totalDocs,
    }),
    shallowEqual
  );

  const initBannerInfo = {
    b_name: '',
    b_ordering: totalCount !== null ? totalCount + 1 : '',
    banner_file: '',
    status: true,
    isin_wp:true,
    isin_wix:true,
    isin_shopify:true,
    isin_bc:true,
    isin_venderportal:true
  };

  const { marketingBannerForEdit } = useSelector(
    (state) => ({
      marketingBannerForEdit: id ? state.banners?.marketingbannerForEdit : undefined,
    }),
    shallowEqual
  );

  // Subheader
  const suhbeader = useSubheader();

  // Tabs
  const [tab, setTab] = useState("basic");
  const [title, setTitle] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const dispatch = useDispatch();

  useEffect(() => {
    if (!id) {
      suhbeader.setBreadcrumbs([{pathname:'/marketing', title:'Marketing Materials'},{pathname:'', title:'Add Banner'}]);
    } else {
      suhbeader.setBreadcrumbs([{pathname:'/marketing', title:'Marketing Materials'},{pathname:'', title:'Edit Banner'}]);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useMemo(async () => {
    if (id === undefined) {
      return;
    }

    await dispatch(fetchSingleMarketingBanner(id));

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id, dispatch]);

  // set Title
  useMemo(() => {
    let _title = id ? "" : "Add Banner";
    suhbeader.setTitle(_title);
    setTitle(_title);

    if (id) {
      _title = "Edit Banner";
      setTitle(_title);
      suhbeader.setTitle(_title);
    }
    return {
      _title,
    };
  }, [id, suhbeader]);

  const saveBannerInfo = (values) => {
    setIsLoading(true);
    if (!id) {
      dispatch(createMarketingBanner(values)).then(async (data) => {
        if (data.payload.status) {
          if (data && data.payload) {
            await history.push(`/marketing`);

            await enqueueSnackbar(data.payload.message, {
              variant: "success",
              autoHideDuration: 4500,
            });
            setIsLoading(false);
          }
        } else {
          if(data.payload.message.includes("Banner validation failed")){
            await enqueueSnackbar("Unsupported file format", {
              variant: "error",
              autoHideDuration: 4500,
            });
          }else{
            await enqueueSnackbar(data.payload.message, {
              variant: "error",
              autoHideDuration: 4500,
            });
          }
          
          setIsLoading(false);
        }
      });
    } else {
      dispatch(updateMarketingBanner(values, id)).then(async (data) => {
        if (data.payload.status) {
          if (data && data.payload) {
            await history.push(`/marketing`);
            await enqueueSnackbar(data.payload.message, {
              variant: "success",
              autoHideDuration: 4500,
            });

            setIsLoading(false);
          }
        } else {
          await enqueueSnackbar(data.payload.message, {
            variant: "error",
            autoHideDuration: 4500,
          });

          setIsLoading(false);
        }
      });
    }
  };

  const btnRef = useRef();
  const saveBannerButtonClick = () => {
    if (btnRef && btnRef.current) {
      btnRef.current.click();
    }
  };

  const backToList = () => {
    history.push(`/marketing`);
  };

  return (
    <Card>
      {false && <ModalProgressBar />}

      <CardHeader title={title}>
        <CardHeaderToolbar>
          <button
            type='button'
            onClick={backToList}
            className='btn btn-light'>
            <i className='fa fa-arrow-left'></i>
            Back
          </button>
          {`  `}

          {`  `}
          <button
            type='submit'
            className='btn btn-primary ml-2'
            disabled={isLoading}
            onClick={saveBannerButtonClick}>
              {isLoading ? "Saving..." : "Save"}
          </button>
        </CardHeaderToolbar>
      </CardHeader>
      <CardBody>
       
        <div className='mt-5'>
         
            <BannerEditAddForm
              banner = {marketingBannerForEdit || initBannerInfo}
              id={id}
              btnRef={btnRef}
              saveBannerInfo={saveBannerInfo}
            />
          
          {/* If you add new tab than add more */}
        </div>
      </CardBody>
      <hr />
      <CardHeader title=''>
        <CardHeaderToolbar>
          <button
            type='button'
            onClick={backToList}
            className='btn btn-light'>
            <i className='fa fa-arrow-left'></i>
            Back
          </button>
          {`  `}

          {`  `}
          <button
            type='submit'
            className='btn btn-primary ml-2'
            disabled={isLoading}
            onClick={saveBannerButtonClick}>
              {isLoading ? "Saving..." : "Save"}
          </button>
        </CardHeaderToolbar>
      </CardHeader>
    </Card>
  );
}
